import { FC } from 'react';
import { Box, Flex, Text } from 'src/components/ui';
import 'src/styles/loader.css';

interface LoadingItemProps {
	isLoading: boolean;
	text: string;
	step: number;
	currentStep: number;
	size?: 'sm' | 'md' | 'lg';
}

const LoadingItem: FC<LoadingItemProps> = ({
	text,
	isLoading,
	step,
	currentStep,
	size,
}) => {
	const loadingCircle = () => {
		return (
			<Box className="load-circle-loading" ml={2} mr={-2}>
				<svg width="23" height="23" viewBox="0 0 100 100">
					<circle className="circle-bg-loading" cx="50" cy="50" r="45"></circle>
					<circle
						className={
							step - 1 === currentStep
								? `circle-loading-${step}`
								: 'circle-bg-loading'
						}
						cx="50"
						cy="50"
						r="45"
					></circle>
				</svg>
			</Box>
		);
	};
	const checkMark = () => {
		return (
			<Box className="checkmark">
				<span className="checkmark">
					<div className="checkmark_stem"></div>
					<div className="checkmark_kick"></div>
				</span>
			</Box>
		);
	};

	return (
		<Flex
			alignItems="center"
			justifyContent="flex-start"
			color="white"
			borderRadius="5px"
			gap={size === 'lg' ? 5 : 3}
			py={3}
			px={1}
		>
			<Box>{isLoading ? loadingCircle() : checkMark()}</Box>
			<Text color="white" size={size}>
				{text}
			</Text>
		</Flex>
	);
};

export default LoadingItem;
